import { paths } from '@luxuryescapes/contract-svc-merchandise'
import requestUtils from 'api/requestUtils'
import qs from 'qs'
import mapMerchandiseOffer from './mapMerchandiseOffer'

type Response = paths['/api/merchandise/adverts']['get']['responses']['200']['content']['application/json']

function getMerchandiseByManyIds(ids: Array<string>): Promise<Array<App.MerchandiseOffer>> {
  const query = qs.stringify({
    advertIds: ids,
  }, { arrayFormat: 'comma' })

  return requestUtils.get<Response>(`/api/merchandise/adverts?${query}`).then(response => {
    return response.result.adverts?.map(mapMerchandiseOffer) ?? []
  })
}

export default getMerchandiseByManyIds
